import { Button, styled } from "@mui/material";

/**
 * CssButtonContained component is a styled Material-UI Button with custom styles.
 *
 * @param {object} props - Component props.
 * @param {string} [props.width="60%"] - Button width.
 * @param {string} [props.height="66px"] - Button height.
 * @param {string} [props.colorText] - Text color of the button.
 * @param {string} [props.backgroundColor] - Background color of the button.
 * @param {string} [props.boxShadowColor] - Box shadow color of the button.
 * @param {string} [props.border] - Border color of the button on hover.
 * @param {string} [props.backgroundColorHover] - Background color of the button on hover.
 *
 * @returns {JSX.Element} Styled Material-UI Button component.
 */

export const CssButtonContained = styled(Button, {
  shouldForwardProp: (prop) =>
    ![
      "colorText",
      "backgroundColor",
      "boxShadowColor",
      "borderRadius",
      "border",
      "backgroundColorHover",
      "width",
      "height",
    ].includes(prop),
})(
  ({
    theme,
    colorText,
    width,
    height,
    backgroundColor,
    boxShadowColor,
    borderRadius,
    border,
    backgroundColorHover,
  }) => ({
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "15px 25px",
    gap: "10px",
    width: width || "60%",
    fontFamily: "Lexend",
    textTransform: "none",
    fontWeight: 500,
    height: height || "66px",
    fontSize: 19,
    backgroundColor,
    borderRadius: borderRadius || "32px",
    color: colorText || theme.palette.text.primary,
    boxShadow: boxShadowColor ? `10px 10px 37px 0px ${boxShadowColor}` : "none",
    "&:hover": {
      border: border ? `5px solid ${border}` : undefined,
      backgroundColor: backgroundColorHover,
      fontFamily: "Lexend",
      textTransform: "none",
      fontWeight: 500,
    },
  }),
);
